import {createZipInstance, SHARED_STRINGS, SHEET} from "./gen.js";
import * as funcs from "./funcs.js";

const parser = new DOMParser();
const serializer = new XMLSerializer();
const SST_SI = parser.parseFromString('<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\n<si><t></t><phoneticPr fontId="1" type="noConversion"/></si>', "text/xml").firstChild;

export class ExcelExporter {

    /** @type {Document} */
    shared_strings
    /** @type {Document} */
    sheet

    constructor() {
        this.folders = createZipInstance();
        this.shared_strings = parser.parseFromString(SHARED_STRINGS, "text/xml");
        this.sheet = parser.parseFromString(SHEET, "text/xml");
        this.sheetData = this.sheet.querySelector("sheetData");
        this.templateNode = this.sheetData.querySelector('row[r="2"]');
        this.sheetData.removeChild(this.templateNode);
        this.templateText = [...this.templateNode.querySelectorAll("c>v")].map(e=>
            this.shared_strings.firstChild.childNodes[+e.textContent].firstChild.textContent
        );
        this.sheetDimension = this.sheet.querySelector("dimension").attributes.getNamedItem("ref");
        this.strings = {};
    }

    // Shared string 추가
    push_shared(str) {
        const cached = this.strings[str];
        if (cached !== undefined) {
            return cached;
        }

        const idx = ++this.shared_strings.firstChild.attributes.getNamedItem("count").value;
        ++this.shared_strings.firstChild.attributes.getNamedItem("uniqueCount").value;

        const si = SST_SI.cloneNode(1);
        si.firstChild.textContent = str;
        this.shared_strings.firstChild.appendChild(si);

        return this.strings[str] = idx-1;
    }

    // 포멧 함수 실행
    exec_func(context, action) {
        let content = context[action[0]];
        if (action[1]) {
            const func = funcs[action[1]];
            if (!func) throw `function ${action[1]} is undefined`;
            content = func(content, context);
        }
        return content;
    }

    // PaymentData 추가
    push_item(item) {
        /** @type {Node} */
        const node = this.templateNode.cloneNode(1);
        this.sheetData.appendChild(node);
        const row = this.sheetData.childNodes.length + "";
        node.attributes.getNamedItem("r").value = row;
        node.querySelectorAll("c>v").forEach((value, idx)=>{
            value.textContent = this.push_shared(this.templateText[idx].replaceAll(
                /\${([^}]*)}/g,
                (_,matched)=> this.exec_func(item, matched.split(","))
            ));
            const r = value.parentNode.attributes.getNamedItem("r");
            r.value = r.value.replace(/\d+$/, row);
        })
        this.sheetDimension.value = this.sheetDimension.value.replace(/\d+$/, row);
    }

    // 최종 파일 다운로드
    async finalize() {
        this.folders["/xl"].file(
            "sharedStrings.xml",
            serializer.serializeToString(this.shared_strings).replaceAll(/<si xmlns="">/g, "<si>")
        );
        this.folders["/xl/worksheets"].file(
            "sheet1.xml",
            serializer.serializeToString(this.sheet)
        );
        try {
            const content = await this.folders["/"].generateAsync({ type: "blob" })
            const link = document.createElement('a');
            link.href = URL.createObjectURL(content);
            link.download = "고지서.xlsx";
            link.click();
            return true;
        } catch (err) {
            console.error("ZIP 파일 생성 중 오류 발생:", err);
            throw err;
        }
    }
}
